import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Button from "../../components/CustomButtons/Button";
import { Grid, makeStyles, withStyles } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import brandTheme from "brandTheme/Theme";
import PersonalInfoReview from "./PersonalInfoReview";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import IncomeDetailsReview from "./IncomeDetails";
import ReferenceReview from "./ReferenceDetails";
import LoanDetailsReview from "./LoanDetails";
import RepaymentDetails from "./RepaymentDetails";
import AddressDetails from "./AddressDetails";
import BankDetails from "./BankDetails";
import DocumentReview from "./DocumentReview";
import MandateDetails from "./MandateDetails";
import styles from "assets/jss/material-dashboard-react/views/modalStyle";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import GridContainer from "views/components/Grid/GridContainer";
import GridItem from "views/components/Grid/GridItem";

const useStyles = makeStyles(styles);
const style = (theme) => ({
  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    margin: "0 5px 0 0 ",
    letterSpacing: "1px",
    height: "40px",
    backgroundColor: brandTheme.buttonColor,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
      boxShadow: "inherit",
    },
  },
});

const PersonalLoanReview = () => {
  const classes = useStyles();
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const status = location?.state?.status || "INPROCESS";
  const [incomeDetails, setIncomeDetails] = useState({});
  const [generalDetails, setGeneralDetails] = useState({});
  const [referenceDetails, setReferenceDetails] = useState({});
  const [loanDetails, setLoanDetails] = useState({});
  const [documentDetails, setDocumentDetails] = useState({});
  const [repaymentDetails, setRepaymentDetails] = useState({});
  const [userLeadIdDetails, setUserLeadIdDetails] = useState({});
  const [addressDetails, setAddressDetails] = useState({});
  const [bankDetails, setBankDetails] = useState({});
  const [adhaarDetails, setAdhaarDetails] = useState({});
  const [photoDetails, setPhtotDetails] = useState({});
  const [mandateDetails, setMandateDetails] = useState({});
  const [eligibleAmountDetails, setEligibleAmountDetails] = useState("");
  const [bankAnalyzerDetails, setBankAnalyzerDetails] = useState({});
  const [callInProgress, setCallInProgress] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [cibilDetails, setCibilDetails] = useState({});
  useEffect(() => {
    getIncomeDetails();
    getCiiblData();
  }, [params]);

  const getIncomeDetails = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_ALL_LEAD_DETAILS + params?.loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (!result?.data?.error_code) {
      setIncomeDetails(result?.data?.incomeDetail);
      setGeneralDetails(result?.data?.applicantDetail);
      setReferenceDetails(result?.data?.leadRefferal);
      setLoanDetails(result?.data?.leadLoanDetail);
      setDocumentDetails(result?.data?.leadDocumentDetail);
      setRepaymentDetails(result?.data?.leadReaymentDetail);
      setUserLeadIdDetails(result?.data?.leadApplication);
      setAddressDetails(result?.data?.applicantAddress);
      setBankDetails(result?.data?.applicantBankDetail);
      setAdhaarDetails(result?.data?.aadharDetails);
      setPhtotDetails(result?.data?.photoDetails);
      setMandateDetails(result?.data?.mandateDetails);
      setEligibleAmountDetails(
        result?.data?.leadApplication?.max_eligible_loan_amount
      );
    }
  };
  const getCiiblData = async () => {
        setCallInProgress(true);
        const result = await apiHandler({
          url: endpoint.GET_CUSTOMER_CIBIL + params?.loanApplicationId,
          method: "GET",
          authToken: authToken,
        });
        setCallInProgress(false);
        if(!result?.data?.error_code){
          setCibilDetails(result?.data);
        }
      }
      const getBankAnalyzerDetails = async () => {
        try {
          setCallInProgress(true);
          const result = await apiHandler({
            url: endpoint.GET_BANK_ANALYZER + params?.loanApplicationId,
            method: "GET",
            authToken: authToken,
          });
          console.log(result?.data, "bankAnalyzerDetails");
          if (result?.data?.error_code) {
            return;
          }
          const bankAnalyzerData = result?.data;
          const reportLink = bankAnalyzerData?.reportLink;
          if (reportLink) {
            try {
              const reportResult = await apiHandler({
                url: `/proxy/s3?url=${encodeURIComponent(reportLink)}`,
                method: "GET",
                authToken: authToken,
              });
              console.log(reportResult?.data, "bankAnalyzerReportData");
              setBankAnalyzerDetails(reportResult?.data);
            } catch (reportError) {
              console.error(
                "Error fetching bank analyzer report:",
                reportError
              );
            }
          }
        } catch (error) {
          console.error("Error fetching bank analyzer details:", error);
        } finally {
          setCallInProgress(false);
        }
      };
        useEffect(() => {
          getBankAnalyzerDetails();
        }, [params?.loanApplicationId]);
  const handlecreateuserSubmit = async () => {
    // setNext();
  };
  return (
    <Grid container style={{maxWidth:'1600px', textAlign:'center', margin:'0 auto'}}>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="REVIEW SCREEN" />
      </Grid>
      <GridContainer
        style={{ margin: "0 auto", width: "100%", textAlign: "left" }}
      >
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {generalDetails && (
            <>
              <PersonalInfoReview
                classes={classes}
                documentDetails={documentDetails}
                generalDetails={generalDetails}
                userLeadIdDetails={userLeadIdDetails}
                photoDetails={photoDetails}
              />
            </>
          )}
          {incomeDetails && (
            <>
              <IncomeDetailsReview
                classes={classes}
                incomeDetails={incomeDetails}
                userLeadIdDetails={userLeadIdDetails}
                adhaarDetails={adhaarDetails}
              />

            </>
          )}
          {loanDetails?.loanAmount > 0 && (
            <>
              <LoanDetailsReview
                classes={classes}
                loanDetails={loanDetails}
                eligibleAmountDetails={eligibleAmountDetails}
                repaymentDetails={repaymentDetails}
                cibilDetails={cibilDetails}
              />

            </>
          )}
          {repaymentDetails && repaymentDetails?.loanAmount > 0 && (
            <>
              <RepaymentDetails
                classes={classes}
                repaymentDetails={repaymentDetails}
              />

            </>
          )}
          {referenceDetails && referenceDetails?.length > 0 && (
            <>
              <ReferenceReview
                classes={classes}
                referenceDetails={referenceDetails}
              />

            </>
          )}
          {addressDetails && addressDetails?.length > 0 && (
            <>
              <AddressDetails
                classes={classes}
                addressDetails={addressDetails}
              />

            </>
          )}
          {bankDetails && bankDetails?.bankAccountNo && (
            <>
              <BankDetails classes={classes} bankDetails={bankDetails} bankAnalyzerDetails={bankAnalyzerDetails}/>

            </>
          )}
          {documentDetails?.sanctionletter && (
            <>
              <DocumentReview
                classes={classes}
                documentDetails={documentDetails}
              />

            </>
          )}
          {mandateDetails?.mandateId && (
            <>
              <MandateDetails
                classes={classes}
                mandateDetails={mandateDetails}
              />

            </>
          )}

          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={() => navigate("/AdminPortal",  { state: { status: status} })}
              >
                Cancel
              </Button>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

PersonalLoanReview.propTypes = {
  classes: PropTypes.object,
  loanApplicationId: PropTypes.object,
};

export default withStyles(style)(PersonalLoanReview);
